<template>
  <div class="project-list-item">
    <router-link :to="{ name: 'projects.show.details', params: { project_id: project.id } }" class="project-list-heading">
      <div class="row">
        <div class="col-10">
          <img v-if="project.client && project.client.logo" :src="project.client.logo" alt="" class="thumbnail rounded">
          <div v-else class="thumbnail rounded bg-light"></div>
          <p>
            <span class="strong">{{ project.title }}</span><br/>
            <span class="d-inline-block mt-1 text-muted">{{ project.client ? project.client.company : '-' }}</span>
          </p>
        </div>
        <div class="col-2 justify-content-end">
          <img
            v-if="project.project_owner"
            class="project-avatar"
            :title="project.project_owner.name"
            :src="getAvatar(project.project_owner.id)"
          />
        </div>
      </div>
    </router-link>

    <ul v-if="project.stages && project.stages.length" class="project-stages">
      <li v-for="stage in project.stages" :key="stage.id">
        <router-link :to="{ name: stageRouteName(stage), params: { project_id: project.id, sprint_id: 'active', stage_id: stage.id } }">
          <div class="row">
            <div class="col-12 col-lg-5">
              <p>{{ stage.stage.name }}</p>
            </div>
            <div class="col-6 col-lg-3">
              <p>
                <span class="data-label d-lg-none">Dates:</span>
                {{ stage.commenced | moment('DD MMM YYYY') }} - <span v-if="stage.completed">{{ stage.completed | moment('DD MMM YYYY') }}</span>
              </p>
            </div>
            <div class="col-6 col-lg-2">
              <ul class="project-members">
                <li v-if="stage.lead" class="lead">
                  <i class="fal fa-crown"></i>
                  <img :src="getAvatar(stage.lead.id)" :title="'Lead: ' + stage.lead.name">
                </li>
                <li v-for="member in stage.members" :key="member.id">
                  <img :src="getAvatar(member.id)" :title="member.name">
                </li>
              </ul>
            </div>
            <div class="col-12 col-lg-2 justify-content-lg-end">
              <span v-if="['Warranty', 'Evaluation'].includes(stage.warranty_status)" class="status" :class="statusClass(stage.warranty_status)">{{ stage.warranty_status }}</span>
              <span v-else-if="stage.status" class="status" :class="statusClass(stage.status.name)">{{ stage.status.name }}</span>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      required: true,
      type: Object
    }
  },

  methods: {
    stageRouteName (stage) {
      return 'projects.stage' + stage.stage.id + '.overview'
    },

    getAvatar (id) {
      return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar'
    },

    statusClass (statusName) {
      if (statusName) {
        return {
          'status-mute': statusName == 'Pending',
          'status-primary': statusName == 'In Progress',
          'status-warning': statusName == 'In Evaluation',
          'status-success': statusName == 'Complete'
        }
      }
    }
  }
}
</script>
